/**
 * Integrasi Zoom lembaga — halaman sendiri di menu samping (Super Admin saja).
 * Server menguji kredensial sebelum menyimpannya, dan Client Secret tidak pernah
 * dikirim kembali, jadi kolomnya selalu kosong saat dibuka.
 */
import React from 'react'
import toast from 'react-hot-toast'
import { useApp } from '../context/AppContext'
import { Btn } from '../shared/components'
import ZoomLogo from '../shared/ZoomLogo'
import {
  getZoomSettings, saveZoomSettings, testZoomSettings, deleteZoomSettings,
} from '../api/settings.api'

const KOSONG = { accountId: '', clientId: '', clientSecret: '', hostEmail: '', minAttendancePct: 75 }

function ZoomCard({ lang }) {
  const id = lang === 'id'
  const [info, setInfo] = React.useState(null)
  const [form, setForm] = React.useState(KOSONG)
  const [open, setOpen] = React.useState(false)
  const [busy, setBusy] = React.useState(false)

  const terapkan = (r) => {
    setInfo(r)
    if (r.connected) {
      setForm({ accountId: r.accountId, clientId: r.clientId, clientSecret: '', hostEmail: r.hostEmail, minAttendancePct: r.minAttendancePct })
    }
  }
  React.useEffect(() => {
    getZoomSettings().then(terapkan).catch(() => setInfo({ connected: false }))
  }, [])

  const ubah = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }))
  const galat = (err) => toast.error(err?.response?.data?.error || err.message)

  const simpan = async (e) => {
    e.preventDefault()
    setBusy(true)
    try {
      terapkan(await saveZoomSettings({
        accountId: form.accountId.trim(),
        clientId: form.clientId.trim(),
        hostEmail: form.hostEmail.trim(),
        minAttendancePct: Number(form.minAttendancePct),
        ...(form.clientSecret.trim() ? { clientSecret: form.clientSecret.trim() } : {}),
      }))
      setOpen(false)
      toast.success(id ? 'Zoom terhubung' : 'Zoom connected')
    } catch (err) { galat(err) } finally { setBusy(false) }
  }

  const uji = async () => {
    setBusy(true)
    try {
      const r = await testZoomSettings()
      toast.success(id ? `Koneksi berhasil: ${r.hostEmail}` : `Connection works: ${r.hostEmail}`)
    } catch (err) { galat(err) } finally { setBusy(false) }
  }

  const putuskan = async () => {
    const pesan = id
      ? 'Putuskan akun Zoom?\n\nMeeting yang sudah dibuat tetap ada di Zoom, tetapi GLADHY tidak bisa lagi mengubahnya atau mengambil data kehadirannya.'
      : 'Disconnect the Zoom account?\n\nExisting meetings stay in Zoom, but GLADHY can no longer change them or collect their attendance.'
    if (!window.confirm(pesan)) return
    setBusy(true)
    try {
      await deleteZoomSettings()
      setInfo({ connected: false })
      setForm(KOSONG)
      setOpen(false)
    } catch (err) { galat(err) } finally { setBusy(false) }
  }

  if (!info) return <p className="muted">{id ? 'Memuat...' : 'Loading...'}</p>
  return (
    <div className="card" style={{ maxWidth: 640, padding: '20px 24px' }}>
      <div className="row between" style={{ alignItems: 'center', gap: 16 }}>
        <div>
          <div style={{ fontWeight: 600 }}>
            {info.connected ? (id ? 'Terhubung' : 'Connected') : (id ? 'Belum terhubung' : 'Not connected')}
          </div>
          <div className="muted" style={{ fontSize: 13, marginTop: 2 }}>
            {info.connected
              ? (id
                ? `Host ${info.hostEmail} · hadir bila mengikuti minimal ${info.minAttendancePct}% sesi`
                : `Host ${info.hostEmail} · present after attending at least ${info.minAttendancePct}% of a session`)
              : (id
                ? 'Hubungkan akun Zoom berbayar lembaga Anda untuk membuat meeting otomatis.'
                : 'Connect your institution\'s paid Zoom account to create meetings automatically.')}
          </div>
        </div>
        {!open && (
          <div className="row gap-2" style={{ flexShrink: 0 }}>
            {info.connected && <Btn onClick={uji} disabled={busy}>{id ? 'Uji koneksi' : 'Test'}</Btn>}
            <Btn onClick={() => setOpen(true)}>{info.connected ? (id ? 'Ubah' : 'Edit') : (id ? 'Hubungkan' : 'Connect')}</Btn>
          </div>
        )}
      </div>
      {open && (
        <form onSubmit={simpan} className="col gap-3" style={{ marginTop: 16 }}>
          <div className="field">
            <label className="field-label">Account ID</label>
            <input className="input" value={form.accountId} onChange={ubah('accountId')} autoComplete="off" required />
          </div>
          <div className="field">
            <label className="field-label">Client ID</label>
            <input className="input" value={form.clientId} onChange={ubah('clientId')} autoComplete="off" required />
          </div>
          <div className="field">
            <label className="field-label">Client Secret</label>
            <input className="input" type="password" value={form.clientSecret} onChange={ubah('clientSecret')} autoComplete="new-password"
              required={!info.connected}
              placeholder={info.connected ? (id ? 'Kosongkan bila tidak diganti' : 'Leave blank to keep') : ''} />
          </div>
          <div className="field">
            <label className="field-label">{id ? 'Email host Zoom' : 'Zoom host email'}</label>
            <input className="input" type="email" value={form.hostEmail} onChange={ubah('hostEmail')} required />
          </div>
          <div className="field">
            <label className="field-label">{id ? 'Batas hadir (% dari durasi sesi)' : 'Attendance threshold (% of session length)'}</label>
            <input className="input" type="number" min={1} max={100} value={form.minAttendancePct} onChange={ubah('minAttendancePct')} required style={{ maxWidth: 120 }} />
          </div>
          <div className="row gap-2">
            <Btn variant="primary" type="submit" disabled={busy}>
              {busy ? (id ? 'Menguji…' : 'Testing…') : (id ? 'Uji dan simpan' : 'Test and save')}
            </Btn>
            <Btn type="button" onClick={() => setOpen(false)}>{id ? 'Batal' : 'Cancel'}</Btn>
            {info.connected && <Btn type="button" variant="ghost" onClick={putuskan} disabled={busy}>{id ? 'Putuskan' : 'Disconnect'}</Btn>}
          </div>
        </form>
      )}
    </div>
  )
}

export default function ZoomScreen() {
  const { lang, user } = useApp()
  const id = lang === 'id'
  const bolehAtur = user?.role === 'SUPER_ADMIN'

  return (
    <div className="main-inner">
      <div className="page-header">
        <div className="page-header-text">
          <div className="row gap-3" style={{ alignItems: 'center' }}>
            <ZoomLogo size={36} />
            <h1 className="h1" style={{ margin: 0 }}>Zoom</h1>
          </div>
          <p className="muted" style={{ marginTop: 8 }}>
            {id
              ? 'Meeting otomatis untuk sesi daring dan hybrid, serta kehadiran dari laporan peserta Zoom.'
              : 'Automatic meetings for remote and hybrid sessions, with attendance from Zoom participant reports.'}
          </p>
        </div>
      </div>

      <div className="mt-4">
        {bolehAtur
          ? <ZoomCard lang={lang} />
          : <p className="muted">{id ? 'Hanya Super Admin lembaga yang dapat mengatur integrasi Zoom.' : 'Only the institution\'s Super Admin can manage the Zoom integration.'}</p>}
      </div>

      <div className="card mt-4" style={{ maxWidth: 640, padding: '20px 24px' }}>
        <div style={{ fontWeight: 600 }}>{id ? 'Cara kerja' : 'How it works'}</div>
        <ul className="muted" style={{ fontSize: 13, margin: '8px 0 0', paddingLeft: 18, lineHeight: 1.7 }}>
          <li>{id ? 'Butuh akun Zoom berbayar dan aplikasi Server-to-Server OAuth.' : 'Requires a paid Zoom account and a Server-to-Server OAuth app.'}</li>
          <li>{id ? 'Buat sesi Daring atau Hybrid dan kosongkan URL, maka meeting dibuat otomatis.' : 'Create a Remote or Hybrid session and leave the URL blank to get a meeting automatically.'}</li>
          <li>{id ? 'Peserta bergabung lewat tombol Gabung di GLADHY agar kehadirannya cocok.' : 'Participants join through the Join button in GLADHY so attendance can be matched.'}</li>
          <li>{id ? 'Kehadiran masuk setelah meeting berakhir dan dapat ditinjau di Detail Sesi.' : 'Attendance arrives after the meeting ends and can be reviewed in Session Detail.'}</li>
        </ul>
      </div>
    </div>
  )
}
